import { constants } from '../../../common';

const { bindingTypes, writeScopes } = constants;

export const normalizeMapping = (mapping) => {
   if (mapping && typeof mapping === 'object' && mapping.type) {
      const hasPersistedWriteScope = Object.prototype.hasOwnProperty.call(mapping, 'writeScope');
      return {
         type: mapping.type || 'none',
         valueColumn: typeof mapping.valueColumn === 'undefined' ? null : mapping.valueColumn,
         noBindingType: typeof mapping.noBindingType === 'undefined' ? bindingTypes.READ.id : mapping.noBindingType,
         // Missing legacy scope displays/behaves as Location. Present malformed values remain distinguishable until repaired.
         writeScope: hasPersistedWriteScope ? mapping.writeScope : writeScopes.LOCATION
      };
   }

   return { type: 'none' };
};

export const isWritableMapping = (mapping) =>
   mapping && (mapping.noBindingType === bindingTypes.WRITE.id || mapping.noBindingType === bindingTypes.READWRITE.id);

export const canonicalWriteScopeSelection = (value) => {
   if (value === writeScopes.LOCATION || value === writeScopes.GLOBAL) return value;
   return null;
};
